var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-info-container" },
    _vm._l(_vm.list, function (section, index) {
      return _c(
        "div",
        { key: index, staticClass: "detailSection" },
        [
          _c("div", { staticClass: "title" }, [_vm._v(_vm._s(section.title))]),
          _c(
            "ul",
            { staticClass: "list" },
            _vm._l(section.list, function (item, i) {
              return _c(
                "li",
                { key: i, staticClass: "item", class: item.colClass },
                [
                  item.label
                    ? _c("div", { staticClass: "lang" }, [
                        _vm._v(_vm._s(item.label) + "："),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "value" },
                    [
                      item.slot
                        ? _vm._t(item.slot, null, { row: item })
                        : _c("span", { class: item.class }, [
                            _vm._v(_vm._s(item.value)),
                          ]),
                    ],
                    2
                  ),
                ]
              )
            }),
            0
          ),
          section.bottomSlot ? _vm._t(section.bottomSlot) : _vm._e(),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }